/** Safe API error text for toast (avoids passing objects to UI code that expects strings). */
export function errMsg(e: unknown, fallback: string): string {
  if (typeof e === "string") return e;
  const ax = e as { response?: { data?: { detail?: unknown; message?: string } }; message?: string };
  const d = ax?.response?.data?.detail;
  if (d != null) {
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
      const parts = d.map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object" && "msg" in item) return String((item as { msg: unknown }).msg);
        try {
          return JSON.stringify(item);
        } catch {
          return String(item);
        }
      });
      const joined = parts.filter(Boolean).join("; ");
      if (joined) return joined;
    }
  }
  const m = ax?.response?.data?.message || ax?.message;
  if (typeof m === "string" && m) return m;
  return fallback;
}

/** Ensures https:// for webhook URLs entered without a scheme. */
export function normalizeWebhookUrl(input: string): string {
  const t = (input || "").trim();
  if (!t) return "";
  if (/^https?:\/\//i.test(t)) return t;
  return `https://${t}`;
}
